import { getCurrentUrlParameter } from 'utils/url';

/**
 * AVS-4405: reads the `?dealerId=` handover (AVP Portal) and removes it from the URL, whatever its value.
 * Returns the trimmed value, or undefined when the param is absent or empty. Does not validate or select it:
 * the dealer gate validates it with the same rules as a dialog choice (AC4/AC7).
 * The param is gone after the read, so a gate run that is cancelled afterwards loses it by design.
 */
export function takeDealerIdFromUrl(): string | undefined {
  const dealerIdParam = getCurrentUrlParameter('dealerId');

  // Param is entirely absent from the URL — nothing to read or strip
  if (dealerIdParam === undefined) {
    return undefined;
  }

  const url = new URL(window.location.href);
  url.searchParams.delete('dealerId');
  window.history.replaceState(null, '', url.toString());

  // getCurrentUrlParameter JSON-parses the value, so a numeric-looking param arrives as a number
  return String(dealerIdParam).trim() || undefined;
}
